import type { ReactNode } from 'react';

// `\w` is ASCII-only even under the `u` flag; `\p{M}` keeps decomposed accents inside the word.
const NAME_WORD = String.raw`[\p{L}\p{M}\p{N}_][\p{L}\p{M}\p{N}_'-]*`;
const MENTION_PATTERN = new RegExp(String.raw`@(?:[^\s@]+@[^\s@][^\s@.]*\.[^\s@]+|${NAME_WORD} ${NAME_WORD})`, 'gu');

/**
 * Render comment text with each `@email` or `@First Last` mention highlighted
 * and its `@` dropped; text without mentions comes back unchanged.
 */
export function renderContentWithMentions(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = MENTION_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <span key={match.index} className="font-semibold text-secondary-blue">
        {match[0].slice(1)}
      </span>
    );
    lastIndex = MENTION_PATTERN.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? <>{parts}</> : text;
}
